import { useMemo } from 'react'
import { AuditEvent } from '@medplum/fhirtypes'
import dayjs from 'dayjs'
import type { ResourceTypeCount } from './timelineUtils'
import {
  groupAuditEventsByDate,
  buildResourceCounts,
  getResourceTypeLabel,
  LABEL_MAP,
} from './timelineUtils'

// Re-export for convenience
export type { ResourceTypeCount }
export { getResourceTypeLabel, LABEL_MAP }

export type DateGroup = {
  date: string // YYYY-MM-DD
  displayDate: string // "Dec 1, 2025"
  totalCount: number
  resourceCounts: ResourceTypeCount[]
}

export function useGroupedTimeline(resources: AuditEvent[]): DateGroup[] {
  return useMemo(() => {
    if (!resources.length) return []

    const dateMap = groupAuditEventsByDate(resources)
    const groups: DateGroup[] = []

    for (const [date, events] of dateMap) {
      groups.push({
        date,
        displayDate: dayjs(date).format('MMM D, YYYY'),
        totalCount: events.length,
        resourceCounts: buildResourceCounts(events),
      })
    }

    // Sort groups by date (newest first)
    groups.sort((a, b) => b.date.localeCompare(a.date))

    return groups
  }, [resources])
}
